import { 
  postPayment,
  getPckgMembership,
  getPckgDesignShop,
  getPckgProductUpload,
  getPckgAdditional,
  checkingPromo
} from '@/api/alibabapayment.api'

export const POST_PAYMENT_ALIBABA = 'POST_PAYMENT_ALIBABA'
export const POST_PAYMENT_ALIBABA_LOADING = 'POST_PAYMENT_ALIBABA_LOADING'
export const POST_PAYMENT_ALIBABA_DONE = 'POST_PAYMENT_ALIBABA_DONE'
export const POST_PAYMENT_ALIBABA_ERROR = 'POST_PAYMENT_ALIBABA_ERROR'

export const FETCH_PACKAGE_MEMBERSHIP = 'FETCH_PACKAGE_MEMBERSHIP'
export const FETCH_PACKAGE_MEMBERSHIP_LOADING = 'FETCH_PACKAGE_MEMBERSHIP_LOADING'
export const FETCH_PACKAGE_MEMBERSHIP_DONE = 'FETCH_PACKAGE_MEMBERSHIP_DONE'
export const FETCH_PACKAGE_MEMBERSHIP_ERROR = 'FETCH_PACKAGE_MEMBERSHIP_ERROR'

export const FETCH_PACKAGE_DESIGNSHOP = 'FETCH_PACKAGE_DESIGNSHOP'
export const FETCH_PACKAGE_DESIGNSHOP_LOADING = 'FETCH_PACKAGE_DESIGNSHOP_LOADING'
export const FETCH_PACKAGE_DESIGNSHOP_DONE = 'FETCH_PACKAGE_DESIGNSHOP_DONE'
export const FETCH_PACKAGE_DESIGNSHOP_ERROR = 'FETCH_PACKAGE_DESIGNSHOP_ERROR'

export const FETCH_PACKAGE_PRODUCT_UPLOAD = 'FETCH_PACKAGE_PRODUCT_UPLOAD'
export const FETCH_PACKAGE_PRODUCT_UPLOAD_LOADING = 'FETCH_PACKAGE_PRODUCT_UPLOAD_LOADING'
export const FETCH_PACKAGE_PRODUCT_UPLOAD_DONE = 'FETCH_PACKAGE_PRODUCT_UPLOAD_DONE'
export const FETCH_PACKAGE_PRODUCT_UPLOAD_ERROR = 'FETCH_PACKAGE_PRODUCT_UPLOAD_ERROR'

export const FETCH_PACKAGE_ADDITIONAL = 'FETCH_PACKAGE_ADDITIONAL'
export const FETCH_PACKAGE_ADDITIONAL_LOADING = 'FETCH_PACKAGE_ADDITIONAL_LOADING'
export const FETCH_PACKAGE_ADDITIONAL_DONE = 'FETCH_PACKAGE_ADDITIONAL_DONE'
export const FETCH_PACKAGE_ADDITIONAL_ERROR = 'FETCH_PACKAGE_ADDITIONAL_ERROR'

export const POST_CHECKING_PROMO = 'POST_CHECKING_PROMO'
export const POST_CHECKING_PROMO_LOADING = 'POST_CHECKING_PROMO_LOADING'
export const POST_CHECKING_PROMO_DONE = 'POST_CHECKING_PROMO_DONE'
export const POST_CHECKING_PROMO_ERROR = 'POST_CHECKING_PROMO_ERROR'

export default {
  [POST_PAYMENT_ALIBABA] (context, payload) {
    context.commit(POST_PAYMENT_ALIBABA_LOADING)
    return postPayment(payload)
      .then((response) => {
        context.commit(POST_PAYMENT_ALIBABA_DONE, response)
      })
      .catch((error) => {
        context.commit(POST_PAYMENT_ALIBABA_ERROR, error)
      })
  },

  [FETCH_PACKAGE_MEMBERSHIP] (context) {
    context.commit(FETCH_PACKAGE_MEMBERSHIP_LOADING)
    return getPckgMembership()
      .then((response) => {
        context.commit(FETCH_PACKAGE_MEMBERSHIP_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PACKAGE_MEMBERSHIP_ERROR, error)
      })
  },

  [FETCH_PACKAGE_DESIGNSHOP] (context) {
    context.commit(FETCH_PACKAGE_DESIGNSHOP_LOADING)
    return getPckgDesignShop()
      .then((response) => {
        context.commit(FETCH_PACKAGE_DESIGNSHOP_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PACKAGE_DESIGNSHOP_ERROR, error)
      })
  },

  [FETCH_PACKAGE_PRODUCT_UPLOAD] (context) {
    context.commit(FETCH_PACKAGE_PRODUCT_UPLOAD_LOADING)
    return getPckgProductUpload()
      .then((response) => {
        context.commit(FETCH_PACKAGE_PRODUCT_UPLOAD_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PACKAGE_PRODUCT_UPLOAD_ERROR, error)
      })
  },

  [FETCH_PACKAGE_ADDITIONAL] (context) {
    context.commit(FETCH_PACKAGE_ADDITIONAL_LOADING)
    return getPckgAdditional()
      .then((response) => {
        context.commit(FETCH_PACKAGE_ADDITIONAL_DONE, response)
      })
      .catch((error) => {
        context.commit(FETCH_PACKAGE_ADDITIONAL_ERROR, error)
      })
  },

  [POST_CHECKING_PROMO] (context, payload) {
    context.commit(POST_CHECKING_PROMO_LOADING)
    return checkingPromo(payload)
      .then((response) => {
        context.commit(POST_CHECKING_PROMO_DONE, response)
      })
      .catch((error) => {
        context.commit(POST_CHECKING_PROMO_ERROR, error)
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/alibabaPayment/actions.js